module.exports = __webpack_public_path__ + "static/media/img-8.bf1faf0e.jpg";